<template>
  <Modal v-model="modal" :title="$t('name.user_log.pay.title')" width="350" footer-hide>
    <Form ref="form" :model="form" :rules="rule">
      <FormItem :label="$t('name.user_log.pay.money')" prop="money">
        <Input v-model="form.money" style="width: 100%;"/>
      </FormItem>
    </Form>
    <Button type="primary" :loading="loading" @click="onRedsys()" long>{{ $t('name.user_log.pay.redsys') }}</Button>
  </Modal>
</template>
<script>
import { redsys } from '@/api/pay'

export default {
  data() {
    return {
      modal: false,
      loading: false,
      form: {
        money: 0
      },
      rule: {
        money: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open() {
      this.modal = true
    },
    success() {
      this.$Modal.confirm({
        title: this.$t('name.user_log.pay.title'),
        content: this.$t('name.user_log.pay.success'),
        onOk: () => {
          this.$emit('get')
          this.modal = false
        },
      });
    },
    onRedsys() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          redsys(this.form).then(res => {
            // 动态创建表单
            const form = document.createElement('form')
            form.style = "display:none;"
            form.method = 'post'
            form.action = res.url
            form.target = '_blank'
            
            // 加入参数
            const input = (name, value) => {
              const i = document.createElement('input')
              i.name = name
              i.value = value
              form.appendChild(i)
            }
            
            input('Ds_SignatureVersion', res.Ds_SignatureVersion)
            input('Ds_MerchantParameters', res.Ds_MerchantParameters)
            input('Ds_Signature', res.Ds_Signature)
            
            // 开始提交并销毁
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
            this.success()
          })
        }
      })
    }
  }
}
</script>